// removed by extract-text-webpack-plugin
module.exports = {"colorPrimaryOrange":"#e16e46","shadeDark":"rgba(49, 47, 48, 1)","colorBackground":"rgb(245, 244, 243)","colorBoxShadowDark":"rgba(49, 47, 48, 0.15)","container":"dropzone__container____1zmB_","dropzone":"dropzone__dropzone____3tKeX","disabled":"dropzone__disabled____2Sujn"};


//////////////////
// WEBPACK FOOTER
// ./src/admin/ui/components/dropzone/dropzone.css
// module id = 430
// module chunks = 0